// extracted by mini-css-extract-plugin
export default {"illustration":"Graph_illustration__sm9xp","arrayItem":"Graph_arrayItem__GG1Qi","rectangle":"Graph_rectangle__zWdS1","green":"Graph_green__GrMm2","orange":"Graph_orange__BbRra"};